import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { requireAuth } from './hocs/PrivateRoute';
const VideoCallNew = lazy(() => import('./containers/videoCallNew/index'));
const PreJoinVideoCall = lazy(
  () => import('./containers/videoCallNew/PreJoinVideoCall/index'),
);
const PreJoinVideoCallDaily = lazy(
  () => import('./containers/DailyVideoCallPreJoin/index'),
);
const TwilioVideoCall = lazy(
  () => import('./containers/twilioVideoCall/index'),
);
const TwilioVideoCallFunctional = lazy(
  () => import('./containers/twilioVideoCallFunctional/index'),
);

// Onboarding
// import Login from './containers/onboarding/Login';
// import ForgotPassword from './containers/onboarding/ForgotPassword';

// import ResetPassword from './containers/onboarding/ResetPassword';
// import Signup from './containers/onboarding/Signup';
// import CompleteProfile from './containers/onboarding/CompleteProfile';
// Patient Pages
// import PatientContainer from './containers/patient';

// Superadmin Pages
// import SuperadminContainer from './containers/superadmin';

// Doctor Pages
// import DoctorContainer from './containers/doctor';

// Hr Pages
// import HrContainer from './containers/hr';

// import VideoCall from './containers/videoCall/index';
const VideoCall = lazy(() => import('./containers/videoCall/index'));
// import PageNotFound from './components/PageNotFound';

const PageNotFound = lazy(() => import('./components/PageNotFound'));
const CompanySpecificPage = lazy(
  () => import('./components/CompanySpecificPage'),
);
const PublicSubscriptionPage = lazy(
  () => import('./components/PublicSubscriptionPage'),
);
const SubscriptionSuccessfulPage = lazy(
  () => import('./components/SubscriptionSuccessfulPage'),
);

// CareCoordinator Pages
// import CareCoordinatorContainer from './containers/careCoordinator';
// import UpdateEmail from './containers/onboarding/UpdateEmail';
// import ViewProfile from './containers/onboarding/ViewProfile';

const CareCoordinatorContainer = lazy(
  () => import('./containers/careCoordinator'),
);
const UpdateEmail = lazy(() => import('./containers/onboarding/UpdateEmail'));
const ViewProfile = lazy(() => import('./containers/onboarding/ViewProfile'));

const Login = lazy(() => import('./containers/onboarding/Login'));
const ForgotPassword = lazy(
  () => import('./containers/onboarding/ForgotPassword'),
);
const ResetPassword = lazy(
  () => import('./containers/onboarding/ResetPassword'),
);
const Signup = lazy(() => import('./containers/onboarding/Signup'));
const CompleteProfile = lazy(
  () => import('./containers/onboarding/CompleteProfile'),
);

const PatientContainer = lazy(() => import('./containers/patient'));
const SuperadminContainer = lazy(() => import('./containers/superadmin'));
const DoctorContainer = lazy(() => import('./containers/doctor'));
const HrContainer = lazy(() => import('./containers/hr'));

// v5's <Redirect from="/:url*(/+)" to=.../> equivalent: strip trailing slashes.
const TrailingSlashRedirect: React.FC = () => {
  const { pathname, search } = useLocation();
  if (pathname !== '/' && /\/+$/.test(pathname)) {
    return <Navigate replace to={pathname.replace(/\/+$/, '') + search} />;
  }
  return null;
};

// Auth-guarded routes render through requireAuth (same guard as v5, now
// returning an element-producing component).
const PatientGuard = requireAuth(PatientContainer);
const SuperadminGuard = requireAuth(SuperadminContainer);
const DoctorGuard = requireAuth(DoctorContainer);
const HrGuard = requireAuth(HrContainer);
const CareCoordinatorGuard = requireAuth(CareCoordinatorContainer);
const CompleteProfileGuardPatient = requireAuth(CompleteProfile);
const CompleteProfileGuardDoctor = requireAuth(CompleteProfile);

const Routers: React.FC<{}> = () => {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <TrailingSlashRedirect />
        {/* Onboarding Flow */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/superadmin/login" element={<Login />} />
          <Route path="/doctor/login" element={<Login />} />
          <Route path="/hr/login" element={<Login />} />
          <Route path="/carecoordinator/login" element={<Login />} />
          <Route path="/forgot-password/*" element={<ForgotPassword />} />
          <Route path="/reset-password/*" element={<ResetPassword />} />
          <Route path="/signup/*" element={<Signup />} />
          <Route path="/update-email/*" element={<UpdateEmail />} />
          <Route path="/view-profile/*" element={<ViewProfile />} />
          <Route
            path="/patient/complete-profile"
            element={<CompleteProfileGuardPatient />}
          />
          <Route
            path="/doctor/complete-profile"
            element={<CompleteProfileGuardDoctor />}
          />

          {/* Patient Flow */}
          <Route path="/patient/*" element={<PatientGuard />} />

          {/* Superadmin Flow */}
          <Route path="/superadmin/*" element={<SuperadminGuard />} />

          {/* Doctor Flow */}
          <Route path="/doctor/*" element={<DoctorGuard />} />

          {/* Doctor Flow */}
          <Route path="/hr/*" element={<HrGuard />} />

          {/* CareCoordinator Flow */}
          <Route path="/carecoordinator/*" element={<CareCoordinatorGuard />} />
          <Route path="/video" element={<VideoCall />} />
          <Route path="/video/v2" element={<VideoCallNew />} />
          <Route path="/video/v2/:uuid" element={<VideoCallNew />} />
          <Route path="/video/v3/prejoin/:id" element={<PreJoinVideoCall />} />
          <Route
            path="/video/v4/prejoin/:id"
            element={<PreJoinVideoCallDaily />}
          />
          <Route path="/video/v3/:id" element={<TwilioVideoCall />} />
          {/* <Route path="/video/v4/" element={<TwilioVideoCallFunctional />} /> */}
          <Route path="/video/:uuid" element={<VideoCall />} />
          {/* <Route path="/video/v3/:id" element={<TwilioVideoCall />} /> */}

          {/* <Route path="/video2/:uuid" element={<VideoCallNew />} /> */}
          <Route path="/subscribe" element={<PublicSubscriptionPage />} />
          <Route
            path="/subscription-successful"
            element={<SubscriptionSuccessfulPage />}
          />
          <Route path="/:companyroute" element={<CompanySpecificPage />} />

          <Route path="*" element={<PageNotFound className="outer-404-page" />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
};

export default Routers;
